import { z } from 'zod';

export const HangoutStatusSchema = z.enum(['live', 'closed']);

export const HangoutSchema = z.object({
    id: z.number().int().positive(),
    name: z.string().min(1),
    venue: z.string().nullable(),
    startingStake: z.number().int().positive(),
    maxStakePerMarket: z.number().int().positive(),
    status: HangoutStatusSchema,
    createdBy: z.number().int().positive(),
    startsAt: z.coerce.date().nullable(),
    closedAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
});

export type Hangout = z.infer<typeof HangoutSchema>;

// GET /hangouts/current returns null when nothing is running.
export const CurrentHangoutSchema = HangoutSchema.nullable();

export const StandingSchema = z.object({
    hangoutId: z.number().int().positive(),
    userId: z.number().int().positive(),
    handle: z.string().min(1),
    balance: z.number().int(),
    eliminatedAt: z.coerce.date().nullable(),
    finishRank: z.number().int().positive().nullable(),
    isLive: z.boolean(),
});

export type Standing = z.infer<typeof StandingSchema>;

export const StandingsSchema = z.array(StandingSchema);

export const MyEntrySchema = z.object({
    balance: z.number().int(),
    maxStakePerMarket: z.number().int(),
    eliminatedAt: z.coerce.date().nullable(),
    finishRank: z.number().int().positive().nullable(),
});

export type MyEntry = z.infer<typeof MyEntrySchema>;


// The list view carries a little extra so past nights are worth browsing.
export const HangoutSummarySchema = HangoutSchema.extend({
    players: z.number().int(),
    markets: z.number().int(),
    winner: z.string().nullable(),
});
export type HangoutSummary = z.infer<typeof HangoutSummarySchema>;
export const HangoutSummariesSchema = z.array(HangoutSummarySchema);

export const ResultSchema = z.object({
    hangoutId: z.number().int().positive(),
    userId: z.number().int().positive(),
    handle: z.string(),
    finalBalance: z.number().int(),
    startingStake: z.number().int(),
    finishRank: z.number().int().positive(),
    eliminatedAt: z.coerce.date().nullable(),
});
export type Result = z.infer<typeof ResultSchema>;
export const ResultsSchema = z.array(ResultSchema);
